import { Workplace } from '../../../../graphql/graphql';
import { WorkplacesTreeItem } from '../../../Manager/Components/WorkplaceManager/ManagerWorkplaceWrapper/ManagerWorkplaceWrapper';

export default function buildWorkplaceTree(
	items: Workplace[],
): WorkplacesTreeItem[] {
	const nodesById: Record<string, WorkplacesTreeItem> = {};
	const tree: WorkplacesTreeItem[] = [];

	items.forEach(item => {
		nodesById[item.id] = {
			...item,
			children: [],
		};
	});

	items.forEach(item => {
		const node = nodesById[item.id];
		const parentId = item.parentWorkplaceId;
		if (!parentId) {
			tree.push(node);
			return;
		}
		const parent = nodesById[parentId];
		if (parent) {
			parent.children.push(node);
		} else {
			tree.push(node);
		}
	});

	return tree;
}
